export default "__VITE_ASSET__6aa17dc9__"